import { useQuery } from "@blitzjs/rpc"
import getFilterData from "../../../queries/getFilterData"
import PipelineAutocompleteFilterMulti from "app/core/components/Autocomplete/PipelineMultipleAutocomplete"
import { useEffect } from "react"
import { PipelineStatus } from "app/pipelines/validations"
import React from "react"
import { prepareFilterList } from "../utils/utils"

export default function OptionFilters({ filters, onChange, activeFilterOptions }) {
  const [sortedFilterData, setSortedFilterData] = React.useState({
    brands: [],
    geographies: [],
    languages: [],
    productsSeries: [],
  })

  const [filterData] = useQuery(getFilterData, undefined, { staleTime: Infinity })

  function updateFilters({ field, value }) {
    onChange({
      ...filters,
      [field]: value,
    })
  }

  const filterConfigs = [
    {
      title: "Brand",
      field: "brand",
      value: filters.brand,
      collection: [{ name: "All", disable: false, id: -1 }, ...sortedFilterData?.brands],
      isDisabled: (item) =>
        item.name !== "All" && activeFilterOptions.brands.every((active) => active.id !== item.id),
      optionValue: ({ name }) => ({ name }),
      optionLabel: (item) => item.name,
    },
    {
      title: "Geography",
      field: "geography",
      value: filters.geography,
      collection: [{ name: "All", disable: false, id: -1 }, ...sortedFilterData?.geographies],
      isDisabled: (item) =>
        item.name !== "All" &&
        activeFilterOptions.geographies.every((active) => active.id !== item.id),
      optionValue: ({ name }) => ({ name }),
      optionLabel: (item) => item.name,
    },
    {
      title: "Language",
      field: "language",
      value: filters.language,
      collection: [
        { name: "All", disable: false, id: -1, code: "All" },
        ...sortedFilterData?.languages,
      ],
      isDisabled: (item) =>
        item.name !== "All" &&
        activeFilterOptions.languages.every((active) => active.id !== item.id),
      optionValue: ({ code }) => ({ code }),
      optionLabel: (item) => item.code,
      optionKey: "code",
    },
    {
      title: "Series",
      field: "series",
      value: filters.series,
      collection: [
        { name: "All", disable: false, id: -1, series: "All" },
        ...sortedFilterData?.productsSeries,
      ],
      isDisabled: (item) =>
        item.name !== "All" &&
        activeFilterOptions.series.every((active) => active.series !== item.series),
      optionValue: (item) => item.series,
      optionLabel: (item) => item.series,
    },
    {
      title: "Status",
      field: "status",
      value: filters.status,
      collection: filterData.statuses,
      optionValue: (item) => item,
      optionLabel: (item) => item.name,
      optionKey: "name",
    },
  ]

  useEffect(() => {
    const updated = {
      languages: prepareFilterList(
        filterData.languages,
        "languages",
        "id",
        "name",
        activeFilterOptions
      ),
      geographies: prepareFilterList(
        filterData.geographies,
        "geographies",
        "id",
        "name",
        activeFilterOptions
      ),
      brands: prepareFilterList(filterData.brands, "brands", "id", "name", activeFilterOptions),
      productsSeries: prepareFilterList(
        filterData.productsSeries,
        "series",
        "series",
        "series",
        activeFilterOptions
      ),
    }

    setSortedFilterData(updated)
  }, [activeFilterOptions])

  return (
    <>
      {filterConfigs.map((config, index) => (
        <PipelineAutocompleteFilterMulti
          key={config.field}
          title={config.title}
          field={config.field}
          value={config.value}
          optionKey={config.optionKey || "name"}
          collection={config.collection}
          isDisabled={config.isDisabled}
          optionValue={config.optionValue}
          optionLabel={config.optionLabel}
          onChange={updateFilters}
        />
      ))}
    </>
  )
}
